import { useEffect, useState } from 'react';

export function useHash(): string | null {
	const [hash, setHash] = useState<string | null>(() =>
		typeof window !== 'undefined' ? window.location.hash.slice(1) : null,
	);

	useEffect(() => {
		const updateHash = () => {
			setHash(window.location.hash.slice(1));
		};

		window.addEventListener('hashchange', updateHash);
		return () => window.removeEventListener('hashchange', updateHash);
	}, []);

	return hash;
}
